import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, MenuItem } from '@nextiva/next-ui-components';
import { ArrowDropDown } from '@material-ui/icons';

import {
  ActionsButtonStyles,
  DeleteStyles,
  SelectiveMenuStyles,
} from './selectiveActionMenu.styles';

export const ActionMenu = ({
  active,
  editCondition,
  toggleConditionActive,
  removeCondition,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    editCondition();
  };

  const handleActive = () => {
    handleClose();
    toggleConditionActive();
  };

  const handleRemove = () => {
    handleClose();
    removeCondition();
  };

  return (
    <>
      <ActionsButtonStyles>
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          disableRipple
          onClick={handleClick}
          variant="contained"
          className={anchorEl ? 'button-border ' : ''}
          data-testid="PlatformAdminUI-ActionMenu-Actions"
        >
          Actions
          <ArrowDropDown />
        </Button>
      </ActionsButtonStyles>
      <SelectiveMenuStyles
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        autoFocus
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={handleEdit}
          disableRipple
          data-testid="PlatformAdminUI-ActionMenu-Edit"
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={handleActive}
          disableRipple
          data-testid="PlatformAdminUI-ActionMenu-Activate"
        >
          {active ? 'Deactivate' : 'Activate'}
        </MenuItem>
        <DeleteStyles
          onClick={handleRemove}
          disableRipple
          data-testid="PlatformAdminUI-ActionMenu-Delete"
        >
          Delete
        </DeleteStyles>
      </SelectiveMenuStyles>
    </>
  );
};

ActionMenu.propTypes = {
  active: PropTypes.bool.isRequired,
  editCondition: PropTypes.func.isRequired,
  removeCondition: PropTypes.func.isRequired,
  toggleConditionActive: PropTypes.func.isRequired,
};
